export default {
  backgroundColor: '#ECE8FF',
  // color: '#ECE8FF !important',
};
